<template>
  <div>
    <a-space :size="12">
      <a-button :disabled="disabled" @click="release" shape="round" size="small" type="dashed">发布</a-button>
      <a-button :disabled="disabled" @click="link" shape="round" size="small" type="dashed">关联</a-button>
      <a-button :disabled="disabled" @click="top" shape="round" size="small" type="dashed">置顶</a-button>
      <a-button :disabled="disabled" @click="star" shape="round" size="small" type="dashed">标星</a-button>
      <a-button :disabled="disabled" @click="remove" shape="round" size="small" type="dashed">删除
      </a-button>
      <a-button :disabled="disabled" @click="download" shape="round" size="small" type="dashed">下载
      </a-button>
      <a-button :disabled="disabled" @click="scissor" shape="round" size="small" type="dashed">修图
      </a-button>
      <a-dropdown :disabled="disabled">
        <a-menu @click="rotate" slot="overlay">
          <a-menu-item :key="1">向左逆时针90度</a-menu-item>
          <a-menu-item :key="2">向右顺时针90度</a-menu-item>
        </a-menu>
        <a-button :loading="rotating" shape="round" size="small" type="dashed"> 旋转
          <a-icon v-if="!rotating" type="down"/>
        </a-button>
      </a-dropdown>
      <a-dropdown :disabled="disabled">
        <a-menu @click="cancel" slot="overlay">
          <a-menu-item key="release">取消发布</a-menu-item>
          <a-menu-item key="link">取消关联</a-menu-item>
          <a-menu-item key="top">取消置顶</a-menu-item>
          <a-menu-item key="star">取消标星</a-menu-item>
        </a-menu>
        <a-button shape="round" size="small" type="dashed"> 取消
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
      <BoolSwitch :false-value="0" :true-value="1" @change="search" title="未关联" v-model="queryParams.unlink"/>
      <BoolSwitch :false-value="0" :true-value="1" @change="search" title="置顶" v-model="queryParams.top"/>
      <BoolSwitch :false-value="0" :true-value="1" @change="search" title="标星" v-model="queryParams.star"/>
      <BoolSwitch :false-value="0" :true-value="1" @change="search" title="RAW" v-model="queryParams.raw"/>
    </a-space>
    <DownloadPg :album="album" :load-func="loadFunc" ref="downloadPg"/>
    <FolderSelect :album-id="album.id" @saved="refresh" ref="folderSelect"/>
    <ReleaseForm :album-id="album.id" @saved="refresh" ref="releaseForm"/>
  </div>
</template>

<script>
import api from "../../../../../utils/api";
import func from "../../../../../utils/func";
import ReleaseForm from "./ReleaseForm";
import FolderSelect from "./FolderSelect";
import DownloadPg from "../comps/DownloadPg";
import BoolSwitch from "@/comps/BoolSwitch";

export default {
  name: "ActionBar",
  components: {BoolSwitch, ReleaseForm, FolderSelect, DownloadPg},
  props: {
    album: Object,
    selected: Array,
    queryParams: Object,
  },
  data() {
    return {
      rotating: false,
      loadFunc: api.v1.album.photo.search,
    }
  },
  computed: {
    disabled() {
      return this.selected.length === 0;
    }
  },
  methods: {
    search() {
      this.$emit("search");
    },
    refresh() {
      this.$emit("refresh");
    },
    top() {
      this.action("top", true, "置顶");
    },
    star() {
      this.action("star", true, "标星");
    },
    link() {
      this.$refs.folderSelect.open(this.selected, true, "关联");
    },
    release() {
      this.$refs.releaseForm.open(this.selected);
    },
    download() {
      this.$refs.downloadPg.start(this.selected);
    },
    remove() {
      const self = this;
      this.$confirm({
        title: "温馨提示",
        content: "建议使用取消发布来关闭图片直播显示，删除操作将彻底清除文件数据且不可恢复，确定要删除吗？",
        onOk() {
          api.v1.album.photo
              .delete(self.album.id, self.selected)
              .then(() => {
                self.$emit("refresh", true);
                self.$message.success(`删除成功`);
              })
              .catch((err) => {
                console.log(err); // debug
                self.$message.error(`删除失败`);
              });
        }
      });
    },
    scissor() {
      const self = this;
      return api.v1.album.photo
          .retouch(this.album.id, this.selected)
          .then(() => {
            self.$emit("refresh", true);
            self.$message.success("已提交修图")
          })
          .catch((err) => {
            console.log(err);
            self.$message.error(`请求处理失败`);
          });
    },
    rotate(e) {
      this.rotating = true;
      api.v1.album.photo.rotate(this.album.id, this.selected, e.key)
          .then(() => func.sleep(3000).then(this.refresh)).finally(() => this.rotating = false);
    },
    cancel(e) {
      if (e.key === "link") {
        this.$refs.folderSelect.open(this.selected, false, "取消关联", this.queryParams.folder_id);
      } else {
        let messages = {top: "取消置顶", star: "取消标星", release: "取消发布"};
        this.action(e.key, false, messages[e.key]);
      }
    },
    action(flag, effect, message) {
      const self = this;
      api.v1.album.photo
          .action(this.album.id, this.selected, flag, effect)
          .then(() => {
            self.refresh();
            self.$message.success(`${message}成功`);
          })
          .catch((err) => {
            console.log(err); // debug
            self.$message.error(`${message}失败`);
          });
    }
  }
}
</script>
